module.exports = __webpack_public_path__ + "img/jbt9160_2_1999.prt.4dd99b7b.jpg";